import React from 'react';
import { useNavigate } from 'react-router-dom';
import MobilePageHeader from '@/components/layout/MobilePageHeader';

const ProfileEditHeader: React.FC = () => {
  const navigate = useNavigate();

  return (
    <MobilePageHeader 
      title="Editar Perfil" 
      onBack={() => navigate('/main/feed')} 
    />
  );
};

export default ProfileEditHeader;
